import React from "react";
import { WHATSAPP_LINK } from "../../data/flyzone";

export const WhatsAppButton = () => {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 grid place-items-center w-14 h-14 rounded-full bg-[#25D366] shadow-lg hover:scale-110 transition-transform duration-300"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40" />
      <svg viewBox="0 0 32 32" className="relative w-7 h-7 fill-white">
        <path d="M16.001 3C9.373 3 4 8.373 4 15c0 2.35.676 4.541 1.844 6.393L4 29l7.82-1.807A11.93 11.93 0 0 0 16.001 27C22.628 27 28 21.627 28 15S22.628 3 16.001 3zm0 21.6a9.55 9.55 0 0 1-4.868-1.333l-.35-.208-4.64 1.072 1.09-4.52-.228-.362A9.53 9.53 0 0 1 6.4 15c0-5.293 4.307-9.6 9.601-9.6 5.293 0 9.6 4.307 9.6 9.6 0 5.294-4.307 9.6-9.6 9.6zm5.27-7.19c-.29-.145-1.71-.844-1.975-.94-.264-.097-.457-.145-.65.145-.193.29-.746.94-.915 1.133-.169.193-.337.217-.626.072-.29-.145-1.223-.451-2.33-1.438-.861-.768-1.443-1.717-1.612-2.007-.169-.29-.018-.446.127-.59.13-.13.29-.338.434-.507.145-.169.193-.29.29-.483.097-.193.048-.362-.024-.507-.072-.145-.65-1.566-.89-2.145-.235-.563-.474-.487-.65-.496l-.554-.01c-.193 0-.507.072-.772.362s-1.012.99-1.012 2.41c0 1.422 1.036 2.795 1.18 2.988.145.193 2.04 3.115 4.943 4.368.69.298 1.229.476 1.649.61.693.22 1.324.189 1.823.115.556-.083 1.71-.699 1.951-1.374.241-.676.241-1.255.169-1.374-.072-.12-.264-.193-.554-.338z" />
      </svg>
    </a>
  );
};
